<script setup>
import { useStore } from 'vuex'
import { inject, onMounted, ref } from 'vue'
import EmergencyLiveClasses from '@/components/home/EmergencyLiveClasses.vue'
const studentPanelBaseUrl = inject('studentBaseUrl');
const isHidden = ref(false)
const lastScrollY = ref(0)
const handleScroll = () => {
  const currentScrollY = window.scrollY;
  isHidden.value = currentScrollY > lastScrollY.value && currentScrollY !== 0;
  lastScrollY.value = currentScrollY;
}

onMounted(()=>{
  window.addEventListener("scroll", handleScroll);
})
const store = useStore()
const openMegaMenu = () => {
  store.dispatch('megaMenu/openMenu')
}
</script>
<template>
  <v-container class="cl__section__margin__bottom" :class="[!$vuetify.display.mdAndDown?'cl__section__margin__top':'']" tag="section">
    <EmergencyLiveClasses></EmergencyLiveClasses>
    <v-row :class="{'flex-column-reverse': $vuetify.display.smAndDown}">

      <v-col cols="12" md="6" class=" d-flex align-items-center" >
        <div class="d-flex flex-column align-items-start" :class="[$vuetify.display.mdAndDown?'text-center':'text-right']" style="max-width: 700px">
          <h1 class="font-weight-bold">
            کلاس آنلاین با
            <strong class="font-weight-bold">
              کلاسینو،
              <img src="@/assets/images/main_page/line.svg" alt="underline text">
            </strong>
            <span style="color: rgba(104, 109, 122, 1)">
              یه تجربه متفاوت یه مسیر نو!
            </span>
          </h1>
          <p class="mb-5 cl__section__subtitle">خیلیا میگن موفقیت سخته، ولی ما میگیم کافیه راهش رو بلد باشی! با <strong>آموزش آنلاین</strong> اصولی در <strong>کلاسینو</strong>، می‌تونی خیلی راحت به رویاهات برسی. توی <strong>کلاس‌های آنلاین</strong> ما، اساتید برتر کنکور و مدرس‌های حرفه‌ای با روش‌های جدید و جذاب کمکت می‌کنن آینده‌ی تحصیلیت رو بهتر از چیزی که تصور می‌کنی بسازی.</p>
          <v-btn
            size="large"
            color="#155EEF"
            class="rounded-lg my-4 text-decoration-none font-weight-bold"
            style="letter-spacing: 0"
            :href="studentPanelBaseUrl"
            :width="$vuetify.display.mdAndDown? '100%' : ''"
          >
            تو هم کلاسینویی شو
            <v-icon icon="$mdiChevronLeftBoxOutline" class="mx-2"></v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="d-flex align-items-center" :class="[$vuetify.display.mdAndDown? 'justify-center mt-16':'justify-end']">
        <img class="w-75" src="@/assets/images/main_page/first-view-image-min.webp" alt="first-view-image">
      </v-col>
      <v-col
        :style="{ top: lastScrollY === 0 ? '115px' : '75px' }"
        v-if="$vuetify.display.smAndDown" :class="{ hidden: isHidden }" class="fixed__btn" cols="12" md="12">
        <v-btn
          size="large"
          append-icon="$mdiChevronDown"
          color="primary"
          variant="tonal"
          class="rounded-lg my-0 d-flex justify-content-between font-weight-bold"
          style="letter-spacing: 0"
          width="100%"
          @click="openMegaMenu"
        >
          دوره‌ها
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>


<style lang="scss" scoped>
.fixed__btn{
  @include media-breakpoint-down(md){
    position: fixed;
    z-index: 10;
    background: #fff;
  }
}
.hidden {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
  transition-duration: 0.5s;
}
h1 {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 4.3rem;
  margin-bottom: 1.5rem;
  @include media-breakpoint-down(lg) {
    font-size: 3rem;
  }
  @include media-breakpoint-down(md) {
    font-size: 1.5rem;
    margin-bottom:1rem;
    line-height: 2.3rem;
  }

  strong {
    position: relative;
    font-weight: 800;

    img {
      position: absolute;
      bottom: -10px;
      right: 0;
      width: 160px;
      @include media-breakpoint-down(lg) {
        bottom: -6px;
      }

      @include media-breakpoint-down(md) {
        left: 0;
        width: 75px;
      }
    }
  }
}

</style>
